<template>
  <div class="certificate_detail">
    <ul>
      <li v-for="(item, index) in workerHiddenCredentials" :key="index">
        <div>
          <img
            :src="item.picUrl"
            @click="showImage(workerHiddenCredentials, index)"
            alt=""
          />
        </div>

        <p>{{ item.credentialsName }}</p>
      </li>
    </ul>
    <!-- <imagePreview
            :items="previewImages"
            @clear="clearImages"
        ></imagePreview> -->
    <imagePreview :items="previewImages"></imagePreview>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import imagePreview from './viewImage.vue'
import { Swipe, SwipeItem } from 'mint-ui'
export default {
  components: {
    Swipe,
    SwipeItem,
    imagePreview
  },
  props: {
    workerHiddenCredentials: Array
  },
  data() {
    return {
      indexSwipe: 1
    }
  },
  methods: {
    showImage(images, index) {
      const query = this.$route.query
      this.previewImages = images
      this.$router.push({ query: { ...query, preview: true, index } })
    }
    // clearImages() {
    //     // 清除照片
    // },
  },
  computed: {
    previewImages: {
      get() {
        return this.workerHiddenCredentials
      },
      set(newValue) {
        this.workerHiddenCredentials = newValue
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../../../assets/css/mixin.scss';
.certificate_detail {
  padding: 0 rem(15px) rem(24px);
  ul {
    overflow: hidden;
    li {
      float: left;
      width: rem(342px);
      margin: rem(24px) rem(9px) rem(6px) rem(9px);
      img {
        width: rem(342px);
        height: rem(256px);
        border-radius: rem(16px);
        object-fit: contain;
      }
    }
    p {
      font-family: PingFangSC-Medium;
      font-size: rem(28px);
      margin-top: rem(16px);
      color: #333333;
      font-weight: 500;
    }
  }

  /deep/.mint-swipe-indicators {
    .mint-swipe-indicator {
      opacity: 0.5;
      background: #ffffff;
    }

    .is-active {
      opacity: 1;
      background: #ffffff;
    }
  }
}
</style>
